module.exports = __webpack_public_path__ + "static/img/luxiangjilu.1ff312b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/luxiangjilu.png
// module id = ApMk
// module chunks = 24